import { ThemeIcon, Tooltip } from '@mantine/core';
import { IconCheckbox } from '@tabler/icons-react';
import style from '@theme/common.module.css';
import { ReactElement } from 'react';
import { ACTIVITY_CATEGORY_COLORS, TIMELINE_MARKER_PROPS } from './Timeline/activityCategories';

// Clinical tasks share the Notes category color (Mustard) with the timeline's
// task-completed marker, so a task reads as the same thing wherever it appears.
const TASK_COLOR = ACTIVITY_CATEGORY_COLORS.notes;

interface ClinicalTaskIconProps {
  size?: number;
}

/**
 * Row/marker icon for a clinical task. Same canon as CommunicationTypeIcon:
 * 24px filled circle, Warm White 2px ring, 14px glyph.
 */
export function ClinicalTaskIcon({ size = 14 }: ClinicalTaskIconProps): ReactElement {
  return (
    <Tooltip label="Task" position="top" withArrow>
      <ThemeIcon {...TIMELINE_MARKER_PROPS} className={style.hoverable} bg={TASK_COLOR} aria-label="Task" role="img">
        <IconCheckbox size={size} />
      </ThemeIcon>
    </Tooltip>
  );
}
